import { Paper, Table, TableBody, TableContainer, TableCell, TableHead, TableRow, Button } from '@mui/material';
import React, { CSSProperties } from 'react';
import { IApplicationNotes } from '../../../Interfaces/Application/IApplicationNotes';
import AddIcon from '@mui/icons-material/Add';
import {formatDateToString, getEmployeeName} from '../../../utils/utils';
import {useSelector} from "react-redux";
import { AppState } from '../../../store/rootReducer';
export interface ApplicationNotesProps {
  notes: IApplicationNotes[];
  onAddNote: () => void;
  style: CSSProperties;
}

const ApplicationNotes: React.FC<ApplicationNotesProps> = (props) => {
  const employees = useSelector((state: AppState) => state.applications.employees);
  
  return (
    <div style={{...props.style, padding: 10}}>
      <Button
        variant='outlined'
        color='primary'
        style={{ marginBottom: '1em', width: `fit-content` }}
        onClick={() => {
          props.onAddNote();
        }}
      >
        <AddIcon style={{ color: `primary`, marginRight: `5px` }} />
        Add Note
      </Button>
      <TableContainer component={Paper} style={{ maxWidth: '1500px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Note</TableCell>
              <TableCell align='right'>Created By</TableCell>
              <TableCell align='right'>Created On</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.notes.map((note: IApplicationNotes, key: number) => {
              return (
                <TableRow key={key}>
                  <TableCell component='th' scope='row'>
                    {note.note}
                  </TableCell>
                  <TableCell align='right'>{getEmployeeName(employees, note.employeeId)}</TableCell>
                  <TableCell align='right'>{new Date(note.createdDate).toLocaleString() ?? ''}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ApplicationNotes;
